import axios from 'axios';

export const LOAD_COURSE_SOURCES = 'LOAD_COURSE_SOURCES';

export function loadCourseSources(courseId, sources) {
  return {
    type: LOAD_COURSE_SOURCES,
    courseId,
    sources,
  };
}

export function getCourseSources(courseId) {
  return async (dispatch) => {
    const res = await axios.post('api/courseSources/getCourseSources', {
      courseId,
    });
    const sources = res.data.sources;
    dispatch(loadCourseSources(courseId, sources));
    return sources;
  };
}

export function addOrUpdateCourseSource(courseSource) {
  return async () => {
    const res = await axios.post(
      'api/courseSources/addOrUpdateCourseSource',
      courseSource,
    );
    return res.data;
  };
}

export function removeCourseSource(courseId, sourceId) {
  return async () => {
    const res = await axios.post('api/courseSources/removeCourseSource', {
      courseId,
      sourceId,
    });
    return res.data;
  };
}
